import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Deletes(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='deletes-glance-body'
                cssHeadingClass='deletes-glance-heading'
                cssIconClass='icons8-trash'
                Heading={t('Deletes')}
                DataPoint1={props.DP1}
                DataPoint3={props.DP2 + ' ' + t('Checks')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}